module.exports = __webpack_public_path__ + "img/12.ca71522a.png";